import { observable } from 'mobx';
import { API_ACCOUNT_DETAIL_WITHDRAWAL_ADJUSTMENT, API_ACCOUNT_DETAIL_TRANSFER_ADJUSTMENT } from 'api/endpoints';
import { RootStore } from '../../rootStore';
import { ReservesAndTargets } from './model';
import { AccountDetailStore } from '../accountDetailStore';
import { Flows } from 'pages/Accounts/Detail/enums';

export class AdjustmentStore {
  rootStore: RootStore;
  accountId: string;
  accountDetailStore: AccountDetailStore;
  @observable allData: ReservesAndTargets | null;

  constructor(rootStore: RootStore, accountDetailStore: AccountDetailStore, accountId: string) {
    this.rootStore = rootStore;
    this.accountDetailStore = accountDetailStore;
    this.accountId = accountId;
    this.allData = null;
  }

  fetchAllData = async () => {
    this.rootStore.stores.uiStore.setLoading(true);
    const response = await this.rootStore.stores.apiStore.get<ReservesAndTargets>(
      this.accountDetailStore.flow?.id === Flows.WITHDRAWAL
        ? API_ACCOUNT_DETAIL_WITHDRAWAL_ADJUSTMENT(this.accountId)
        : API_ACCOUNT_DETAIL_TRANSFER_ADJUSTMENT(this.accountId),
    );
    if (response?.data) {
      this.allData = response.data;
    }
    this.rootStore.stores.uiStore.setLoading(false);
  };
}
